fragment InstanceInfo on Instance {
    instanceId
    isPro
    isTrial
    companyName
    hasConfiguredNutshellEmailAutomations
    hasLandingPages
    webfxSiteId
    hasDeprecatedBillingCycle
    daysLeftInTrial
    isBillingManagedByWebfx
    schedulerAccessType
}
